export function httpErrorMessage(error) {
  const response = error && error.response
  if (!response) {
    return error && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')
      ? '连接超时，请稍后重试'
      : '暂时无法连接服务，请检查网络后重试'
  }
  if (response.status >= 500) return '服务暂时不可用，请稍后重试'
  if (response && response.status === 429) {
    const message = response.data && response.data.message
    return typeof message === 'string' && message ? message : '操作频繁，请稍后再试'
  }
  return (response && response.data && response.data.message) ||
    (error && error.message) || '请求失败，请稍后重试'
}

export function mayRetryRequest(config) {
  // A timed-out send/login may already have succeeded. Never replay mutations.
  return !!config && ['get', 'head', 'options'].includes((config.method || 'get').toLowerCase())
}



// WEBPACK FOOTER //
// ./src/utils/httpError.js